/**
 * Reference Library — service layer (docs/REFERENCES.md). Backed by api/reference-library.js
 * (Supabase `reference_library`). Editable in the CRM workspace -> References tab; consumed by
 * CrmReferenceDetailModal's picker.
 */

async function authHeaders() {
  const token = await window.__clerkGetToken()
  return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
}

async function call(method, body) {
  const res = await fetch('/api/reference-library', {
    method, headers: await authHeaders(), body: body ? JSON.stringify(body) : undefined,
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || ('Reference library request failed (' + res.status + ')'))
  return data
}

/** All firm-wide reference entries, active + inactive (sort order). */
export function getReferenceLibrary() {
  return call('GET').then(d => d.entries)
}

export function createReferenceLibraryEntry(fields) {
  return call('POST', { action: 'create', ...fields }).then(d => d.entry)
}
export function updateReferenceLibraryEntry(id, fields) {
  return call('POST', { action: 'update', id, ...fields }).then(d => d.entry)
}
export function deleteReferenceLibraryEntry(id) {
  return call('POST', { action: 'delete', id })
}
export function moveReferenceLibraryEntry(id, direction) {
  return call('POST', { action: 'move', id, direction })
}
